import { useEffect, useState } from "react";
import moment from "moment";

const useCountdown = (targetDate: Date | null) => {
  const countDownDate = new Date(targetDate || new Date()).getTime();

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);
  if (!targetDate) {
    return [];
  }
  return getReturnValues(countDown);
};

const lZero = (num: number) => String(num);

const getReturnValues = (countDown: number) => {
  const years = moment.duration(countDown).years();
  const months = moment.duration(countDown).months();
  const days = moment.duration(countDown).days();
  const hours = moment.duration(countDown).hours();
  const minutes = moment.duration(countDown).minutes();
  const seconds = moment.duration(countDown).seconds();

  return [lZero(years), lZero(months), lZero(days), lZero(hours), lZero(minutes), lZero(seconds)];
};

export { useCountdown };
